import { getTranslation } from "helpers/common";

const required = value =>
  value !== undefined ? undefined : getTranslation("VALIDATION_REQUIRED");

const positive = value =>
  value < 0 ? getTranslation("VALIDATION_ONLY_POSITIVE") : undefined;

const maxLength = maxLength => value =>
  value && value.length > maxLength
    ? `${getTranslation(
        "VALIDATION_MORE_THAN_START"
      )} ${maxLength} ${getTranslation("VALIDATION_MORE_THAN_END")}`
    : undefined;

const exactLength = exactLength => value =>
  value !== undefined && (value + "").length !== exactLength
    ? `${getTranslation(
        "VALIDATION_MUST_CONTAIN_START"
      )} ${exactLength} ${getTranslation("VALIDATION_MUST_CONTAIN_END")}`
    : undefined;

const onlyNumbers = value => {
  const regex = new RegExp("^[0-9]+$");
  return !!value && !regex.test(value)
    ? getTranslation("VALIDATION_ONLY_NUMBERS")
    : undefined;
};

export default { required, positive, maxLength, exactLength, onlyNumbers };
